export function extractMsgTags(str = ""): string[] {
	// 这个正则表达式是为了匹配 <start_dialog> 标签和其后的几种结束标签
	// 1. <start_dialog>...<start_dialog>
	// 2. <start_dialog>...</start_dialog>
	// 3. <start_dialog>...</end_dialog>
	// 4. <start_dialog>...<end_dialog>
	//
	// Breakdown:
	// <start_dialog>   - 匹配字面上的起始标签
	// (.*?)            - 这是一个非贪婪的捕获组，会匹配中间的任何文本。这是我们想要提取的内容。
	// <(\/)?           - 匹配一个 '<' 符号，后面可能有一个可选的 '/'
	// (start_dialog|end_dialog) - 匹配 'start_dialog' 或 'end_dialog'
	// >                - 匹配字面上的结束 '>'
	// g flag           - 全局匹配，找到所有符合条件的实例，而不仅仅是第一个
	const regex = /<start_dialog>(.*?)<(\/)?(start_dialog|end_dialog)>/g;

	// 使用 matchAll 来获取所有匹配项的迭代器
	const matches = preProcessText(str).matchAll(regex);

	// 从匹配项中提取捕获组 (我们想要的内容)，并去除两端的空白
	const extractedTexts = Array.from(matches, (match) => match[1].trim());

	// 将结果数组格式化为美观的 JSON 字符串
	return extractedTexts;
}

/**
 * 这个函数会替换自定义的对话标签为 HTML span 标签。
 * It will replace custom dialog tags with HTML span tags.
 *
 * @param text The input string containing <start_dialog> and <end_dialog> tags.
 * @returns The transformed string with <span class="text-main1">...</span> tags.
 */
export function replaceMsgTags(text = ""): string {
	const result = preProcessText(text)
		.replace(/<start_dialog>/g, '<span class="text-main1">')
		.replace(/<\/start_dialog>/g, "</span>")
		.replace(/<\/end_dialog>/g, "</span>")
		.replace(/<end_dialog>/g, "</span>");
	return result;
}

// 清除全部对话标签
export function cleanMsgTags(str = "") {
	return str.replace(
		/<start_dialog>|<\/start_dialog>|<end_dialog>|<\/end_dialog>/g,
		"",
	);
}

function preProcessText(str: string) {
	const hasEndTag = /<end_dialog>|<\/end_dialog>|<\/start_dialog>/g.test(str);
	if (!hasEndTag) {
		return cleanMsgTags(str);
	}
	return str;
}
